var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.15606 26.9834H8.8091V13.2546L0.733337 7.19775V24.5606C0.733337 25.9012 1.81953 26.9834 3.15606 26.9834Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1909 26.9834H33.8439C35.1845 26.9834 36.2667 25.8972 36.2667 24.5606V7.19775L28.1909 13.2546",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1909 2.75626V13.2547L36.2667 7.19793V3.96762C36.2667 0.971518 32.8466 -0.736505 30.4521 1.06035",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80908 13.2548V2.75635L18.5 10.0245L28.1909 2.75635V13.2548L18.5 20.523",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.733337 3.96762V7.19793L8.8091 13.2547V2.75626L6.54788 1.06035C4.14938 -0.736505 0.733337 0.971518 0.733337 3.96762Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 35.5333,
    height: 26.65,
    fill: "white",
    transform: "translate(0.733337 0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmail_icon.092ea1399aa5678b0d9291ce84578a84.svg";
export { ForwardRef as ReactComponent };